import React from 'react';
import { useLocation } from 'react-router-dom';
import { normalizeAdminRoutePath } from '../../constants/adminPaths';
import AdminAccessCodePage from './AdminAccessCodePage';
import { useAdminAccessGate } from './useAdminAccessGate';

const BYPASS_PREFIXES = [
  '/support-login',
  '/invite/accept',
  '/magic-link',
  '/forgot-password',
  '/reset-password',
  '/__/auth',
  '/paladin',
];

function shouldBypassAdminAccessGate(pathname) {
  const path = normalizeAdminRoutePath(pathname);
  return BYPASS_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export default function AdminAccessGate({ children }) {
  const { pathname } = useLocation();
  const { unlocked, unlockWithCode } = useAdminAccessGate();

  if (shouldBypassAdminAccessGate(pathname)) {
    return children;
  }

  if (!unlocked) {
    return <AdminAccessCodePage onUnlock={unlockWithCode} />;
  }

  return children;
}
